import i18n from "@/locales";
import { $ } from "moneysafe";

const nameFirme = (gfirme, codefirme) => {
  const firme = gfirme.filter(item => item.codefirme === codefirme);
  return firme.length > 0 ? firme[0].namefirme : "";
};

const countFirme = (gfirme, codefirme) => {
  const firme = gfirme.filter(item => item.codefirme === codefirme);
  return firme.length > 0 ? firme[0].rcount : "";
};

const kindName = (gkindpay, kindpay) => {
  const kind = gkindpay.filter(item => item.kindpay === kindpay);
  return kind.length > 0 ? kind[0].kindname : "";
};

const userName = (gusers, userid) => {
  const user = gusers.filter(item => item.userid === userid);
  return user.length > 0 ? user[0].fio : "";
};

const rCount = (account, accountid) => {
  const acc = account.filter(item => item.accountid === accountid);
  return acc.length > 0 ? acc[0].rcount : "";
};

const payName = (codepay, codeplat) => {
  const pay = codepay.filter(item => item.codeplat === codeplat);
  return pay.length > 0 ? pay[0].name : "";
};

const statusName = code => {
  let result = "";
  switch (code) {
    case "0":
      result = i18n.t("common.reference.statusName.inSet");
      break;
    case "1":
      result = i18n.t("common.reference.statusName.inPosting");
      break;
    case "2":
      result = i18n.t("common.reference.statusName.spaced");
      break;
    case "3":
      result = i18n.t("common.reference.statusName.notConnected");
      break;
    case "4":
      result = i18n.t("common.reference.statusName.erroneous");
      break;
    case "7":
    case "8":
    case "9":
      result = i18n.t("common.reference.statusName.canceled");
      break;
    default:
      result = "";
  }
  return result;
};

const paymentName = code => {
  let result = "";
  switch (code) {
    case "1":
      result = i18n.t("common.reference.paymentName.preparationPayment");
      break;
    case "2":
      result = i18n.t("common.reference.paymentName.paymentMade");
      break;
    case "3":
      result = i18n.t("common.reference.paymentName.paymentNotMade");
      break;
    default:
      result = i18n.t("common.reference.paymentName.undefined");
  }
  return result;
};

const deliveryName = code => {
  let result = "";
  switch (code) {
    case "1":
      result = i18n.t("common.reference.deliveryName.moneySent");
      break;
    case "2":
      result = i18n.t("common.reference.deliveryName.paymentNotDeterm");
      break;
    case "3":
      result = i18n.t("common.reference.deliveryName.mismatchAmounts");
      break;
    default:
      result = i18n.t("common.reference.deliveryName.undefined");
  }
  return result;
};

const reasonName = (greason, codereason) => {
  const reason = greason.filter(item => item.codereason === codereason);
  return reason.length > 0 ? reason[0].namereason : "";
};

const streetName = (street, codestreet) => {
  const streets = street.filter(item => item.codestreet === codestreet);
  return streets.length > 0 ? streets[0].namestreet : "";
};

const streetWithTypeName = (street, codestreet) => {
  const streets = street.filter(item => item.codestreet === codestreet);
  return streets.length > 0
    ? `${streets[0].typestr} ${streets[0].namestreet}`
    : "";
};

const regionName = (region, coder) => {
  const regions = region.filter(item => item.coder === coder);
  return regions.length > 0 ? regions[0].namerg : "";
};

const serviceName = (service, codeservice) => {
  const services = service.filter(item => item.codeservice === codeservice);
  return services.length > 0 ? services[0].name : "";
};

const zoneName = (zone, zoneheadid, zoneindex) => {
  const zones = zone.filter(
    item => item.zoneheadid === zoneheadid && item.index === zoneindex
  );
  return zones.length > 0 ? zones[0].zonename : "";
};

const currencyShortName = (gcurrency, codecurrency) => {
  const currencies = gcurrency.filter(
    item => item.codecurrency === codecurrency
  );
  return currencies.length > 0 ? currencies[0].shortname : "";
};

const errorName = (statuspay, coderr) => {
  const statuses = statuspay.filter(item => item.coderr === coderr);
  return statuses.length > 0 ? statuses[0].nameerr : "";
};

const closeReasonName = (gclientclosereason, codeclosereason) => {
  const reasons = gclientclosereason.filter(
    item => item.codeclosereason === codeclosereason
  );
  return reasons.length > 0 ? reasons[0].name : "";
};

const habitName = (ghabit, codehabit) => {
  const habits = ghabit.filter(item => item.codehabit === codehabit);
  return habits.length > 0 ? habits[0].namehabit : "";
};

const propertyName = (gproperty, typesob) => {
  const propertys = gproperty.filter(item => item.typesob === typesob);
  return propertys.length > 0 ? propertys[0].namesob : "";
};

const sortSum = (sum1, sum2) =>
  $(sum1)
    .minus($(sum2))
    .toNumber();

const formatSum = sum =>
  sum.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");

const capitalizeFirstLetter = str => str[0].toUpperCase() + str.slice(1);

export {
  nameFirme,
  countFirme,
  kindName,
  userName,
  rCount,
  payName,
  statusName,
  paymentName,
  deliveryName,
  reasonName,
  streetName,
  streetWithTypeName,
  regionName,
  serviceName,
  zoneName,
  currencyShortName,
  errorName,
  closeReasonName,
  habitName,
  propertyName,
  sortSum,
  formatSum,
  capitalizeFirstLetter
};
